import MultiLanguageInput from "./MultiLanguageInput";

export * from "./MultiLanguageInput";
export default MultiLanguageInput;
